






























































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Process, Step } from '@attensi/api-js';

// TODO !! IMPORTANT CHECK THIS IMPORT
// import * as elementResizeEvent from "element-resize-event";
const elementResizeEvent = require('element-resize-event');

import { $eventBus } from '@/eventBus';

import { VideoClickableRect, VideoClickPosition } from '../../types/VideoTypes';
import { VideoSizer } from './processVideoResizer';
import VideoCursor from './ProcessVideoCursor.vue';

const wait = (ms: number) => new Promise((r, j) => setTimeout(r, ms));

@Component({
  components: { VideoCursor },
})
export default class ProcessVideo extends Vue {
  @Prop({ default: false })
  isReview!: boolean;

  @Getter('processModule/activeStep') activeStep!: Step;
  @Getter('processModule/activeProcess') activeProcess!: Process;

  columnsOpen: boolean = true;
  clickableRect: VideoClickableRect = {
    x: '10%',
    y: '10%',
    height: '10%',
    width: '10%',
  };
  clickPosition: VideoClickPosition = {
    x: 10,
    y: 10,
  };
  viewBox: any = null;
  isPlaying: boolean = false;
  isReplay: boolean = false;
  frameHeight: number = 0;
  frameWidth: number = 0;
  image: any = null;
  cursorAnimationTime: number = 2;
  autoPlayTime: number = 0.5;

  @Watch('activeStep', { immediate: true })
  onActiveStepChanged(): void {
    this.newStepHandler();
  }

  @Watch('activeProcess')
  onActiveProcessChanged(): void {
    this.setPause();
  }

  @Action('processModule/setNextStep') setNextStep!: Function;
  @Action('processModule/setPreviousStep') setPreviousStep!: Function;
  @Action('processModule/setFirstStep') setFirstStep!: Function;

  setPlay(): void {
    this.isPlaying = true;
    this.animateNextStep();
  }

  setPause(): void {
    this.isPlaying = false;
  }

  pauseAndNextStep() {
    this.setPause();
    this.setNextStep();
  }
  pauseAndPreviousStep() {
    this.setPause();
    this.setPreviousStep();
  }

  setClickableRectAndClickPosition(): void {
    const left = this.activeStep.clickBounds.left * 100;
    const top = this.activeStep.clickBounds.top * 100;
    const right = this.activeStep.clickBounds.right * 100;
    const bottom = this.activeStep.clickBounds.bottom * 100;

    this.clickableRect.x = left.toString().concat('%');
    this.clickableRect.width = (right - left).toString().concat('%');
    this.clickableRect.y = top.toString().concat('%');
    this.clickableRect.height = (bottom - top).toString().concat('%');

    this.clickPosition.x = (left + right) / 2;
    this.clickPosition.y = (top + bottom) / 2;
  }

  setMediaControls(): void {
    const lastStepIndex = this.activeProcess.steps[
      this.activeProcess.steps.length - 1
    ].index;
    if (this.activeStep.index === lastStepIndex) {
      this.setPause();
      this.isReplay = true;
    } else {
      this.isReplay = false;
    }
  }

  adjustImage(): void {
    const image: any = this.$refs.videoImage;
    if (!image) { return; }
    if (image.complete) {
      this.onImageLoaded();
    } else {
      image.addEventListener('load', this.onImageLoaded);
      image.addEventListener('error', () => {
        throw Error('Error loading image');
      });
    }
  }

  onImageLoaded(): void {
    const image = this.$refs.videoImage as HTMLImageElement;
    const container = this.$refs.videoContent as HTMLElement;
    const overlay: any = this.$refs.videoOverlay as HTMLElement;
    const videoSizer = new VideoSizer(image, container, overlay);
    videoSizer.setSize();

    this.viewBox = overlay.viewBox;
  }

  async newStepHandler(): Promise<void> {
    // TODO: CHECK WEATHER THIS IS "BULLETPROOF". ITO ASYNC AND AWAIT
    // TODO MAKE ACTUAL AWAIT FOR adjustImage AND onImageLoaded
    await this.adjustImage();
    this.setClickableRectAndClickPosition();
    this.setMediaControls();
    this.animateNextStep();
  }

  async animateNextStep(): Promise<void> {
    // TODO: CHECK WEATHER THIS IS "BULLETPROOF". ITO ASYNC AND AWAIT
    // TODO: IT SEEMS THE EVENT ARE TRIGGERED TWICE; IF isPlaying IS TOGGLED WITHIN THE DEALYS
    if (!this.isPlaying) { return; }
    await wait(250);
    if (!this.isPlaying) { return; }

    this.fireAnimateCursorPositionEvent();

    if (!this.isPlaying) { return; }
    await wait(this.cursorAnimationTime * 1000);
    if (!this.isPlaying) { return; }

    this.fireAnimateCursorClickEvent();

    if (!this.isPlaying) { return; }
    await wait(this.autoPlayTime * 1000);
    if (!this.isPlaying) { return; }

    this.setNextStep();
  }

  fireAnimateCursorClickEvent(): void {
    $eventBus.$emit('animateCursorClick');
  }

  fireAnimateCursorPositionEvent(): void {
    $eventBus.$emit('animateCursorPosition');
  }

  emitCloseAllColumns(): void {
    this.columnsOpen = false;
    $eventBus.$emit('closeAllColumns');
  }

  emitOpenAllColumns(): void {
    this.columnsOpen = true;
    $eventBus.$emit('openAllColumns');
  }

  async mounted(): Promise<void> {
    window.addEventListener('resize', this.adjustImage);

    elementResizeEvent(this.$refs.videoContainer as Element, this.adjustImage);

    await wait(150);
    this.adjustImage();
  }

  destroyed(): void {
    window.removeEventListener('resize', this.adjustImage);
    // TODO FIGURE OUT HOW TO UNSUBSCIBE FROM elementResizeEvent
    // elementResizeEvent.unbind(
    //   this.$refs.videoContainer as Element,
    //   this.adjustImage
    // );
  }
}
